import DeleteToolset from './DeleteToolset';
import ReplaceToolset from './ReplaceToolset';

type ConfirmModalSubComponents = {
  DeleteToolset: typeof DeleteToolset;
  ReplaceToolset: typeof ReplaceToolset;
};

const ConfirmModal: ConfirmModalSubComponents = () => null;

ConfirmModal.DeleteToolset = DeleteToolset;
ConfirmModal.ReplaceToolset = ReplaceToolset;

export default ConfirmModal;
